import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ZoneOption } from "../../../../../shared/geo/zone-option";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** The geo catalogue the address editor's cascade picks from. Loaded when the
 *  editor opens, not with the case: most visits never correct an address. */
export const listGeoCatalog = createAsyncThunk<
  ZoneOption[],
  void,
  { extra: ExtraArgument; state: State }
>(thunkTypes.LIST_GEO_CATALOG, async (_, { extra }) => {
  return await extra.complianceRepo.listGeoCatalog();
});
